<template>
  <div v-if="!event.drawn">
    <btn-run-lottery @fetchTickets="$emit('fetchTickets')"></btn-run-lottery>

    <router-link :to="{name: 'ranking.index', params: {id: event._id}} ">
      <button
        v-if="isRanking && $can('ranking.index')"
        class="btn btn-fill btn-wd btn-success btn-block">
        Gerenciar Ranking
      </button>
    </router-link>
  </div>

  <div v-else>
    <router-link :to="{name: 'ranking.index', params: {id: event._id}}">
      <button
        v-if="isRanking && !$can('ranking.index')"
        class="btn btn-fill btn-wd btn-info btn-block btn-router">
        Vizualizar ranking
      </button>
    </router-link>

    <router-link :to="{name: 'tickets.details'}">
      <button
        v-if="isLottery && $can('tickets.details')"
        class="btn btn-fill btn-wd btn-info btn-block btn-router">
        Registrar presenças
      </button>
    </router-link>

    <btn-open-new-presenter></btn-open-new-presenter>
    <btn-download-pptx v-if="event.downloadWinnersPpt" />
    <btn-download-pptx-substitute-customers v-if="event.downloadWinnersPpt" />
    <btn-download-old-presenter></btn-download-old-presenter>
    <btn-associate-stock @fetchTickets="$emit('fetchTickets')"></btn-associate-stock>
    <btn-print-terms></btn-print-terms>
    <btn-download-documentation></btn-download-documentation>
    <btn-print-all-tickets></btn-print-all-tickets>
    <btn-print-all-tickets :eligibleNotWinners="true"></btn-print-all-tickets>
    <btn-csv-winners v-if="event.downloadWinnersCsv" />
    <btn-csv-winners v-if="event.downloadWinnersCsv" :eligibleNotWinners="true"></btn-csv-winners>
  </div>
</template>
<script>
  import BtnRunLottery from './Actions/BtnRunLottery'
  import BtnAssociateStock from './Actions/BtnAssociateStock'
  import BtnPrintTerms from './Actions/BtnPrintTerms'
  import BtnDownloadOldPresenter from './Actions/BtnDownloadOldPresenter'
  import BtnDownloadDocumentation from './Actions/BtnDownloadDocumentation'
  import BtnOpenNewPresenter from './Actions/BtnOpenNewPresenter'
  import BtnPrintAllTickets from './Actions/BtnPrintAllTickets'
  import BtnDownloadPptx from './Actions/BtnDownloadPptx'
  import BtnDownloadPptxSubstituteCustomers from './Actions/BtnDownloadPptxSubstituteCustomers'
  import BtnCustomersImport from './Actions/BtnCustomersImport'
  import BtnCsvWinners from './Actions/BtnCsvWinners'

  export default {
    name: 'event-actions',

    props: {
      event: {
        required: true
      }
    },

    components: {
      BtnRunLottery,
      BtnAssociateStock,
      BtnPrintTerms,
      BtnDownloadOldPresenter,
      BtnDownloadDocumentation,
      BtnOpenNewPresenter,
      BtnPrintAllTickets,
      BtnDownloadPptx,
      BtnDownloadPptxSubstituteCustomers,
      BtnCustomersImport,
      BtnCsvWinners
    },

    computed: {
      isLottery () {
        return this.event.winnerChoiceMode === 'lottery' || this.event.winnerChoiceMode === ''
      },

      isRanking () {
        return this.event.winnerChoiceMode === 'ranking'
      }
    }
  }
</script>

<style scoped>
  .btn-router {
    margin-bottom: 5px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/Events/EventActions.vue